import { SymbolLayerSpecification } from 'maplibre-gl';

import {
  AcresMapboxLayerIds,
  AcresMapboxSourceIds,
  AcresMapboxVectorSourceLayerIds,
  ZOOM_LEVELS,
} from '..';

export const countyLabelsLayer: SymbolLayerSpecification = {
  id: AcresMapboxLayerIds.COUNTY_LABEL,
  layout: {
    'text-allow-overlap': false,
    'text-field': '{NAME}',
    'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
  },
  maxzoom: ZOOM_LEVELS.COUNTIES.MAX,
  minzoom: ZOOM_LEVELS.COUNTIES.MIN,
  paint: {
    'text-color': 'white',
    'text-halo-color': 'black',
    'text-halo-width': 1.25,
  },
  source: AcresMapboxSourceIds.COUNTIES,
  'source-layer': AcresMapboxVectorSourceLayerIds.COUNTY_CENTROID,
  type: 'symbol',
};
